export default "__VITE_ASSET__B$TrXmRr__"